// This function allow to reference async chunks
__webpack_require__.u = function(chunkId) {
	// return url for filenames based on template
	return "js/" + chunkId + "." + {"381":"56a2d3a2","388":"f81455db"}[chunkId] + ".js";
};